import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllContainerClassesAdminQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllContainerClassesAdminQuery = { __typename?: 'Query', getAllContainerClassesAdmin: Array<string> };


export const GetAllContainerClassesAdminDocument = gql`
    query GetAllContainerClassesAdmin {
  getAllContainerClassesAdmin
}
    `;

/**
 * __useGetAllContainerClassesAdminQuery__
 *
 * To run a query within a React component, call `useGetAllContainerClassesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContainerClassesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContainerClassesAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContainerClassesAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContainerClassesAdminQuery, GetAllContainerClassesAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContainerClassesAdminQuery, GetAllContainerClassesAdminQueryVariables>(GetAllContainerClassesAdminDocument, options);
      }
export function useGetAllContainerClassesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContainerClassesAdminQuery, GetAllContainerClassesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContainerClassesAdminQuery, GetAllContainerClassesAdminQueryVariables>(GetAllContainerClassesAdminDocument, options);
        }
export type GetAllContainerClassesAdminQueryHookResult = ReturnType<typeof useGetAllContainerClassesAdminQuery>;
export type GetAllContainerClassesAdminLazyQueryHookResult = ReturnType<typeof useGetAllContainerClassesAdminLazyQuery>;
export type GetAllContainerClassesAdminQueryResult = Apollo.QueryResult<GetAllContainerClassesAdminQuery, GetAllContainerClassesAdminQueryVariables>;